import { createClient } from '@supabase/supabase-js'
// TODO: Replace with generated types from database.types.ts after running `npm run update-types`
// import type { Database } from './database.types'
import type { Database } from './types'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Please check your .env.local file.')
}

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: false,
    autoRefreshToken: false,
  },
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
  db: {
    schema: 'public',
  },
})

// Helper to set the app.changed_by session variable
export const setChangedBy = async (changedBy: 'admin' | 'guest') => {
  const { error } = await supabase.rpc('exec_sql', {
    query: `SELECT set_config('app.changed_by', '${changedBy}', false)`,
  })
  if (error) {
    console.error('Error setting changed_by:', error)
  }
}
